import { organisationConstants } from '../../../_constants';

const initialState = { getCompetencyPrefillLoading: true, data: '', error: false };

export function CompetencyMetricPrefill(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_PREFILL_COMPETENCY:
            return {
                getCompetencyPrefillLoading: true,
                data: '',
                error: false
            };
        case organisationConstants.RECIEVE_PREFILL_COMPETENCY:
            return {
                getCompetencyPrefillLoading: false,
                data: action.competencyList,
                error: false
            };
        case organisationConstants.ERROR_PREFILL_COMPETENCY:
            return {
                getCompetencyPrefillLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/manageMetric/competencyMetricPrefill.reducer.js